// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","secondary":"Button_secondary__P77oe","danger":"Button_danger__0Dm0k"};